import { z } from 'zod';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_RE = /^[0-9+\s()-]{7,20}$/;

export const emailSchema = z
  .string()
  .min(1, 'Email is required')
  .regex(EMAIL_RE, 'Enter a valid email address')
  .transform((value) => value.trim().toLowerCase());

export const optionalEmailSchema = z
  .string()
  .refine((value) => value === '' || EMAIL_RE.test(value), 'Enter a valid email address')
  .transform((value) => value.trim().toLowerCase());

export const phoneSchema = z
  .string()
  .min(1, 'Phone number is required')
  .regex(PHONE_RE, 'Enter a valid phone number');

export const optionalPhoneSchema = z
  .string()
  .refine((value) => value === '' || PHONE_RE.test(value), 'Enter a valid phone number');

export const nameSchema = z
  .string()
  .trim()
  .min(2, 'Must be at least 2 characters')
  .max(100, 'Too long');

export const messageSchema = z
  .string()
  .trim()
  .min(1, 'Please write a message')
  .max(2000, 'Too long');

export const optionalPriceSchema = z
  .string()
  .refine(
    (value) => value === '' || (/^\d+$/.test(value) && parseInt(value, 10) > 0),
    'Enter a valid price',
  );

export const codeSchema = (length: number) =>
  z
    .string()
    .length(length, `Code must be ${length} digits`)
    .regex(/^\d+$/, 'Digits only');
